module.exports = __webpack_public_path__ + "assets/pencil.97e4eb20.svg";